module.exports = __webpack_public_path__ + "img/gb9115_16.prt.c2cfb070.jpg";